<h1 mat-dialog-title>Applied filters</h1>
<div mat-dialog-content>
  <div #dialogBody></div>
</div>
